module.exports = __webpack_public_path__ + "static/media/npm-icon.3f6cae09.png";